import { useLazyQuery, useMutation } from "@apollo/client/react";import React, { useEffect, useState, useMemo, useCallback } from 'react';

import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { PrecioControlFilters } from './PrecioControlFilters';
import { useGetColumns } from './hooks/useGetColumns';
import { useGetFilters } from './hooks/useGetFilters';
import { useGetRows } from './hooks/useGetRows';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { AUTORIZAR_RECHAZO_MASIVO } from '../../../data/graphQL/mutations/PrecioAutorizacion/autorizacionPrecioMasivo';
import { GET_EXPORTACION_AUTORIZACIONES } from '../../../data/graphQL/queries/AutCambioPrecio/getExportacionAutorizaciones';
import { toast } from 'react-hot-toast';
import { Box, CircularProgress } from '@mui/material';


import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button } from
'@mui/material';
import { downloadExcel } from '../../../utils/downloadExcel';

const ESTADO_PENDIENTE_ID = 1;
const ESTADO_APROBADO_ID = 2;
const ESTADO_RECHAZADO_ID = 3;

export const PrecioControlContent = ({ setChildrenAction }) => {
  const [isRefetchRequired, setIsRefetchRequired] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [modalType, setModalType] = useState(null); // 'aprobar' | 'rechazar'
  const [observacion, setObservacion] = useState('');
  const [errorObs, setErrorObs] = useState(false);

  const {
    filters,
    handleChangeFilters,
    delegaciones,
    estados
  } = useGetFilters(ESTADO_PENDIENTE_ID);

  const {
    rows,
    setRows,
    loading,
    totalCount,
    handleSearch
  } = useGetRows(filters, setIsRefetchRequired);

  const columns = useGetColumns(filters?.idEstado);

  const [autorizarRechazoMasivo, { loading: loadingRechazo }] = useMutation(AUTORIZAR_RECHAZO_MASIVO, {
    onCompleted: () => {
      handleSearch();
      toast.success('Operación realizada con éxito');
      setSelectedRows([]);
    }
  });

  const abrirModal = (tipo) => {
    setModalType(tipo);
    setObservacion('');
    setErrorObs(false);
  };

  const handleConfirmarModal = () => {
    if (!observacion.trim()) {
      setErrorObs(true);
      return;
    }

    const payload = {
      idsAutorizacionControl: selectedRows,
      idEstado: ESTADO_APROBADO_ID,
      observacion
    };
    if (modalType === 'aprobar') {
      autorizarRechazoMasivo({ variables: payload });
    } else if (modalType === 'rechazar') {
      payload.idEstado = ESTADO_RECHAZADO_ID;
      autorizarRechazoMasivo({ variables: payload });
    }

    setModalType(null);
  };

  const handleDescargar = useCallback(async () => {
    downloadExcel({
      fileName: `AutorizacionesCambioPrecio`,
      sheet: 'Datos',
      tablePayload: {
        header: headerExcelAutorizacionesCambioPrecio,
        body: rows
      }
    });
  }, [rows]);

  useEffect(() => {
    setChildrenAction(
      <div className='top-buttons' style={{ gap: 8 }}>
                <CustomButton
          label='Descargar'
          variant='outlined'
          disabled={!rows.length}
          onClick={handleDescargar} />
        
                <CustomButton
          label='Rechazar'
          variant='contained'
          sx={{ background: '#636A73' }}
          disabled={filters?.idEstado !== ESTADO_PENDIENTE_ID}
          onClick={() => abrirModal('rechazar')} />
        
                <CustomButton
          label='Aprobar'
          variant='contained'
          disabled={filters?.idEstado !== ESTADO_PENDIENTE_ID}
          onClick={() => abrirModal('aprobar')} />
        
            </div>
    );
  }, [
  setChildrenAction,
  rows,
  selectedRows,
  filters,
  handleDescargar]
  );

  const handleFilters = (name, value) => {
    setSelectedRows([]);
    setRows([]);
    handleChangeFilters(name, value);
    setIsRefetchRequired(true);
  };

  const onSelect = (value) => {
    setSelectedRows(value);
  };

  if (loadingRechazo) return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20vh' }}>
      <CircularProgress size={40} />
    </Box>
  ); 

  return (
    <div className='grid-container requisitos-clientes-grilla'>
            <PrecioControlFilters
        delegaciones={delegaciones}
        estados={estados}
        filters={filters}
        handleChangeFilters={handleFilters}
        handleSearch={handleSearch}
        estadoPendienteId={ESTADO_PENDIENTE_ID} />
      
            <DataGridGenerico
        checkboxSelection={filters?.idEstado === ESTADO_PENDIENTE_ID}
        disabledSelectionAll
        entityId={'idAutorizacionControl'}
        onRowSelectionModelChange={onSelect}
        rowSelectionModel={selectedRows}
        columns={columns}
        totalCount={totalCount}
        rows={rows}
        toolbar={false}
        loading={loading}
        localeText={{
          noRowsLabel: isRefetchRequired ?
          'Haz click en "Buscar" para aplicar los nuevos filtros' :
          'Sin filas'
        }} />
      

            <Dialog open={!!modalType} onClose={() => setModalType(null)} fullWidth maxWidth="sm">
                <DialogTitle>
                    <strong>{modalType === 'aprobar' ? 'Aprobar autorización' : 'Rechazar autorización'}</strong>
                </DialogTitle>
                <DialogContent sx={{ pt: 1.5 }}>
                    <div style={{ marginBottom: 12, fontSize: 14 }}>
                        Por favor, debe ingresar una observación para el proceso masivo.
                    </div>
                    <TextField
            label="Observación"
            multiline
            rows={4}
            fullWidth
            value={observacion}
            onChange={(e) => {
              setObservacion(e.target.value);
              if (e.target.value.trim()) setErrorObs(false);
            }}
            error={errorObs} />
          
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button onClick={() => setModalType(null)} variant="outlined">
                        CERRAR
                    </Button>
                    <Button
            onClick={handleConfirmarModal}
            variant="contained"
            sx={
            modalType === 'rechazar' ?
            { background: '#636A73', color: 'white', '&:hover': { background: '#4f555d' } } :
            undefined
            }>
            
                        {modalType === 'aprobar' ? 'APROBAR' : 'RECHAZAR'}
                    </Button>
                </DialogActions>
            </Dialog>

        </div>);

};

const headerExcelAutorizacionesCambioPrecio = [
"idAutorizacionControl",
"periodo",
"precioControl",
"precioACambiar",
"evento",
"region",
"delegacion",
"solicitante",
"fecha",
"financiador",
"contrato",
"codigo",
"modulo",
"idMinuta"];